<app-menu-bar-mobile></app-menu-bar-mobile>
<div class="payment-execution">
    <div class="payment-execution__header">
      <h1 class="title">{{ 'PAYMENT_EXECUTE.TITLE' | translate }}</h1>
    </div>
    <div class="payment-execution__message">
        <span>{{ 'PAYMENT_EXECUTE.MESSAGE' | translate }}</span>
    </div>
</div>
